import { useEffect, useRef } from "react";

import Ep62Img from "../../assets/images/conversations/ep-62-peter-varghese.webp";
import Ep61Img from "../../assets/images/conversations/ep-61-montek-singh-ahluwalia.webp";
import Ep60Img from "../../assets/images/conversations/ep-60-thirumalai-nc.webp";
import Ep55Img from "../../assets/images/conversations/ep-55-Amitabh-Kant.webp";
import Ep52Img from "../../assets/images/conversations/ep-52-Uday-Narang.webp";
import Ep51Img from "../../assets/images/conversations/ep-51-Sudhir-Mehta.webp";
import Ep50Img from "../../assets/images/conversations/ep-50-Vijay-Gokhale.webp";
import Ep49Img from "../../assets/images/conversations/ep-49-EV-Charger-OEMs.webp";
import Ep44Img from "../../assets/images/conversations/ep-44-Luca-Fontanelli.webp";
import Ep41Img from "../../assets/images/conversations/ep-41-Manish-Jain.webp";
import Ep40Img from "../../assets/images/conversations/ep-40-Vasudha-Madhavan.webp";
import Ep37Img from "../../assets/images/conversations/ep-37-Fyn.webp";
import Ep36Img from "../../assets/images/conversations/ep-36-Vayve-Mobility.webp";
// import Ep35Img from "../../assets/images/conversations/ep-35-Vasudha-Madhavan.webp";
import Ep34Img from "../../assets/images/conversations/ep-34-Kapil-Shelke.webp";
import Ep32Img from "../../assets/images/conversations/ep-32-MG.webp";
import Ep31Img from "../../assets/images/conversations/ep-31-EV-Super-User.webp";
// import Ep30Img from "../../assets/images/conversations/ep-30-ChargePoint-Operators.webp";
import Ep29Img from "../../assets/images/conversations/ep-29-Ravi-Panga.webp";
import Ep28Img from "../../assets/images/conversations/ep-28-Preeti-Bajaj.webp";
import Ep27Img from "../../assets/images/conversations/ep-27-Awadesh-Jha.webp";
import Ep26Img from "../../assets/images/conversations/ep-26-Karthikeyan-Palanisamy.webp";
import Ep25Img from "../../assets/images/conversations/ep-25-Vijay-Vaitheeswaran.webp";
import Ep24Img from "../../assets/images/conversations/ep-24-Dhwal-Khullar.webp";
import Ep23Img from "../../assets/images/conversations/ep-23-Uday-Narang.webp";
// import Ep22Img from "../../assets/images/conversations/ep-22-Sunfuel-Electric.webp";
import Ep21Img from "../../assets/images/conversations/ep-21-Arun-Vinayak.webp";
import Ep20Img from "../../assets/images/conversations/ep-20-kartikey-Hariyani.webp";
import Ep19Img from "../../assets/images/conversations/ep-19-Cyrus-Dhabar.webp";
import Ep18Img from "../../assets/images/conversations/ep-18-Rajeev-Chaba.webp";
import Ep17Img from "../../assets/images/conversations/ep-17-KR-Jyothilal.webp";
import Ep16Img from "../../assets/images/conversations/ep-16-Alisha-Sachdev.webp";
import Ep15Img from "../../assets/images/conversations/ep-15-Sajid-Mubshir.webp";
import Ep14Img from "../../assets/images/conversations/ep-14-Nishant-Arya.webp";
import Ep12Img from "../../assets/images/conversations/ep-12-kartikey-Hariyani.webp";
import Ep11Img from "../../assets/images/conversations/ep-11-Gaurav-Gupta.webp";
import Ep10Img from "../../assets/images/conversations/ep-10-Naveen-Munjal.webp";
import Ep09Img from "../../assets/images/conversations/ep-09-Nikita-Nishita.webp";
// import Ep08Img from "../../assets/images/conversations/ep-08-EV-Consumer.webp";
import Ep07Img from "../../assets/images/conversations/ep-07-Reji-Kumar.webp";
import Ep06Img from "../../assets/images/conversations/ep-06-Mahesh-Babu.webp";
// import Ep05Img from "../../assets/images/conversations/ep-05-Gigafactories.webp";
import Ep04Img from "../../assets/images/conversations/ep-04-Sulajja-Motwani.webp";
import Ep03Img from "../../assets/images/conversations/ep-03-Tarun-Mehta.webp";
import Ep02Img from "../../assets/images/conversations/ep-02-Stefan-Louis.webp";
import Ep01Img from "../../assets/images/conversations/ep-01-Stefan-Louis.webp";

/* ─────────────────────────────────────────────
   CSS
───────────────────────────────────────────── */
const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&family=Roboto:wght@400;500&display=swap');

  *, *::before, *::after { margin: 0; padding: 0; box-sizing: border-box; }

  .ev-page {
    background: #1A1A1A;
    min-height: 100vh;
    font-family: 'Roboto', sans-serif;
    color: #fff;
  }

  .ev-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding-left: 102px;
    padding-right: 102px;
  }

  .ev-page-title {
    font-family: 'Montserrat', sans-serif;
    font-size: 50px;
    font-weight: 700;
    text-align: center;
    color: #ffffff;
    padding-top: 60px;
    padding-bottom: 60px;
    letter-spacing: -0.5px;
  }

  .ev-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    column-gap: 30px;
    row-gap: 60px;
    padding-bottom: 100px;
  }

  .ev-card-wrap {
    display: flex;
    flex-direction: column;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .ev-card-wrap.ev-visible {
    opacity: 1;
    transform: translateY(0);
  }
  .ev-card-wrap:nth-child(2) { transition-delay: 0.08s; }
  .ev-card-wrap:nth-child(3) { transition-delay: 0.16s; }
  .ev-card-wrap:nth-child(4) { transition-delay: 0.08s; }
  .ev-card-wrap:nth-child(5) { transition-delay: 0.16s; }
  .ev-card-wrap:nth-child(6) { transition-delay: 0.24s; }

  .ev-card {
    border-radius: 10px;
    overflow: hidden;
    cursor: pointer;
    transition: transform 0.35s ease;
    box-shadow: none;
  }
  .ev-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 16px 48px rgba(116, 63, 172, 0.35);
  }
  .ev-card img {
    width: 100%;
    height: 300px;
    display: block;
    border-radius: 10px;
  }

  .ev-card__title {
    font-family: 'Roboto', sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #ffffff;
    line-height: 140%;
    margin-top: 20px;
  }
  .ev-card__read-more {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-family: 'Roboto', sans-serif;
    font-size: 14px;
    font-weight: 500;
    color: #743FAC;
    text-decoration: underline;
    transition: gap 0.25s ease, color 0.25s ease;
    margin-top: 16px;
  }
  .ev-card__read-more:hover {
    gap: 8px;
    color: #9B5FD4;
  }
  .ev-card__read-more svg {
    width: 22px;
    height: 22px;
    flex-shrink: 0;
  }

  /* ── TABLET (max 768px) ── */
  @media (max-width: 768px) {
    .ev-inner { padding-left: 32px; padding-right: 32px; }
    .ev-page-title { font-size: 32px; padding-top: 32px; padding-bottom: 32px; }
    .ev-grid {
      grid-template-columns: repeat(2, 1fr);
      column-gap: 20px;
      row-gap: 40px;
      padding-bottom: 48px;
    }
    .ev-card img { height: 220px; }
    .ev-card__title { margin-top: 18px; font-size: 15px; }
    .ev-card__read-more { margin-top: auto; }
  }

  /* ── MOBILE (max 480px) ── */
  @media (max-width: 480px) {
    .ev-inner { padding-left: 16px; padding-right: 16px; }
    .ev-page-title { font-size: 30px; padding-top: 51px; padding-bottom: 30px; }
    .ev-grid {
      grid-template-columns: 1fr;
      column-gap: 0;
      row-gap: 40px;
    }
    .ev-card img { height: auto; }
    .ev-card__title { font-size: 14px; margin-top: 15px; }
    .ev-card__read-more { margin-top: 10px; }
  }
`;

function ArrowIcon() {
  return (
    <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}

/* ─────────────────────────────────────────────
   EV EPISODE DATA — sourced from energizingindia.tv/ev/
───────────────────────────────────────────── */
const EPISODES = [
  {
    img: Ep62Img,
    alt: "EP 62 Peter Varghese",
    title: "EP 62 | Peter VARGHESE on China's Tech Dominance, Trump's America, & the India-Australia Partnership.",
    href: "/ep-62-peter-varghese-on-chinas-tech-dominance-trumps-america-the-india-australia-partnership",
  },
  {
    img: Ep61Img,
    alt: "EP 61 Montek Singh Ahluwalia",
    title: "EP 61 | 1991: India's Near-Default Moment. How Did We Survive — and in 2025 What Challenges Come Next? | Montek Singh AHLUWALIA",
    href: "/ep-61-1991-indias-near-default-moment-how-did-we-survive-and-in-2025-what-challenges-come-next-montek-singh-ahluwalia",
  },
  {
    img: Ep60Img,
    alt: "EP 60 Thirumalai NC",
    title: "EP 60 | Bangalore's pollution- a victim of its own economic success. Can EVs change that? Thirumalai NC",
    href: "/ep60bangalorepollution/",
  },
  {
    img: Ep55Img,
    alt: "EP 55 Amitabh Kant",
    title: "EP 55 | Inside India's Journey Towards Energy Transition with Amitabh Kant",
    href: "/ep-55-inside-indias-journey-towards-energy-transition-with-amitabh-kant/",
  },
  {
    img: Ep52Img,
    alt: "EP 52 Uday Narang",
    title: "EP 52 | Empowering Sustainable Last Mile Deliveries | Uday Narang",
    href: "/ep-52-empowering-sustainable-last-mile-deliveries-uday-narang/",
  },
  {
    img: Ep51Img,
    alt: "EP 51 Sudhir Mehta",
    title: "EP 51 | Revolutionizing India's Buses: A Startup's Electric Impact | Sudhir Mehta | EKA & Pinnacle Industries",
    href: "/ep-51-revolutionizing-indias-buses-a-startups-electric-impact-sudhir-mehta-eka-pinnacle-industries/",
  },
  {
    img: Ep50Img,
    alt: "EP 50 Vijay Gokhale",
    title: "EP 50 | Unwrapping geopolitics with Vijay GOKHALE",
    href: "/ep-50-unwrapping-geopolitics-with-vijay-gokhale/",
  },
  {
    img: Ep49Img,
    alt: "EP 49 EV Charger OEMs",
    title: "EP 49 | EV Charger OEMs – 3 different journeys | Tirex Chargers | Siemens | Quench",
    href: "/ep-49-ev-charger-oems-3-different-journeys-tirex-chargers-siemens-quench/",
  },
  {
    img: Ep44Img,
    alt: "EP 44 Luca Fontanelli",
    title: "EP 44 | Decentralizing Power: Taking EV Chargers off the grid | E-GAP | Luca FONTANELLI",
    href: "/ep-44-decentralizing-power-taking-ev-chargers-off-the-grid-e-gap-luca-fontanelli/",
  },
  {
    img: Ep41Img,
    alt: "EP 41 Manish Jain",
    title: "From EP 41 | Shaadi.com to EVs – Chat with a EV Super User | Manish Jain",
    href: "/ep-41-shaadi-com-to-evs-chat-with-a-ev-super-user-manish-jain/",
  },
  {
    img: Ep40Img,
    alt: "EP 40 Vasudha Madhavan",
    title: "EP 40 | Finding investors through the funding winter | Vasudha Madhavan",
    href: "/ep-40-finding-investors-through-the-funding-winter-vasudha-madhavan/",
  },
  {
    img: Ep37Img,
    alt: "EP 37 Fyn",
    title: "EP 37 | Rediscovering Sustainable Last Mile Logistics | Fyn",
    href: "/ep-37-rediscovering-sustainable-last-mile-logistics-fyn/",
  },
  {
    img: Ep36Img,
    alt: "EP 36 Vayve Mobility",
    title: "EP 36 | Decoding Solar-Powered Urban Mobility | Vayve Mobility",
    href: "/ep-36-decoding-solar-powered-urban-mobility-vayve-mobility/",
  },
  {
    img: null,
    alt: "EP 35 Vasudha Madhavan",
    title: "EP 35 | Financing your EV start up | Vasudha Madhavan",
    href: "/ep-35-financing-your-ev-start-up-vasudha-madhavan/",
  },
  {
    img: Ep34Img,
    alt: "EP 34 Kapil Shelke",
    title: "EP 34 | Revolutionizing the Electric Experience: An Inside Look at Tork's Vision | Kapil Shelke",
    href: "/ep-34-revolutionizing-the-electric-experience-an-inside-look-at-torks-vision-kapil-shelke/",
  },
  {
    img: Ep32Img,
    alt: "EP 32 MG",
    title: "EP 32 | Navigating the new urban jungle: MG may have a plan",
    href: "/ep-32-navigating-the-new-urban-jungle-mg-may-have-a-plan/",
  },
  {
    img: Ep31Img,
    alt: "EP 31 EV Super User",
    title: "EP 31| Driving into the Future: A Conversation with an EV Super User",
    href: "/ep-31-driving-into-the-future-a-conversation-with-an-ev-super-user/",
  },
  {
    img: null,
    alt: "EP 30 ChargePoint Operators",
    title: "EP 30 | The ChargePoint Operators of India | GOEC | Charge Zone | Zeon | ChargeMod",
    href: "/the-chargepoint-operators-of-india-goec-charge-zone-zeon-chargemod/",
  },
  {
    img: Ep29Img,
    alt: "EP 29 Ravi Panga",
    title: "EP 29 | Sustainable zero emission public transport for India | Ravi Panga | Causis Group Ltd",
    href: "/ep-29-sustainable-zero-emission-public-transport-for-india-ravi-panga-causis-group-ltd/",
  },
  {
    img: Ep28Img,
    alt: "EP 28 Preeti Bajaj",
    title: "EP 28 | Uncovering India's Clean Energy Transition | Preeti Bajaj | Luminous Power Technologies",
    href: "/ep-28-uncovering-indias-clean-energy-transition-preeti-bajaj-luminous-power-technologies/",
  },
  {
    img: Ep27Img,
    alt: "EP 27 Awadesh Jha",
    title: "EP 27 | Concluding the Chicken & Egg story? | Awadesh JHA | Fortum Charge & Drive India",
    href: "/ep-27-concluding-the-chicken-egg-story-awadesh-jha-fortum-charge-drive-india/",
  },
  {
    img: Ep26Img,
    alt: "EP 26 Karthikeyan Palanisamy",
    title: "EP 26 | Electrifying South India | Karthikeyan Palanisamy | Zeon Charging",
    href: "/ep-26-electrifying-south-india-karthikeyan-palanisamy-zeon-charging/",
  },
  {
    img: Ep25Img,
    alt: "EP 25 Vijay Vaitheeswaran",
    title: "EP 25 | Decoding China's Dominance on EVs Globally | The Economist | Vijay VAITHEESWARAN",
    href: "/ep-25-decoding-chinas-dominance-on-evs-globally-the-economist-vijay-vaitheeswaran/",
  },
  {
    img: Ep24Img,
    alt: "EP 24 Dhawal Khullar",
    title: "EP 24 | Building India's First Homegrown Premium Electric Car | Pravaig Dynamics | Dhawal KHULLAR",
    href: "/ep-24-building-indias-first-homegrown-premium-electric-car-pravaig-dynamics-dhawal-khullar/",
  },
  {
    img: Ep23Img,
    alt: "EP 23 Uday Narang",
    title: "EP 23 | The Power Behind Real Sustainable Last Mile Deliveries | Omega Seiki Mobility | Uday NARANG",
    href: "/ep-23-the-power-behind-real-sustainable-last-mile-deliveries-omega-seiki-mobility-uday-narang/",
  },
  {
    img: null,
    alt: "EP 22 Gul Panag Sudhir Nayak",
    title: "EP 22 | Making EVs Mainstream | Sunfuel Electric | Gul PANAG & Sudhir NAYAK",
    href: "/ep-22-making-evs-mainstream-sunfuel-electric-gul-panag-sudhir-nayak/",
  },
  {
    img: Ep21Img,
    alt: "EP 21 Arun Vinayak",
    title: "EP 21 |Achieving the impossible – Rapid Charge in 15 minutes | Arun Vinayak | Exponent Energy",
    href: "/ep-21-achieving-the-impossible-rapid-charge-in-15-minutes-arun-vinayak-exponent-energy/",
  },
  {
    img: Ep20Img,
    alt: "EP 20 Kartikey Hariyani",
    title: "EP 20 | Electrifying Indian Highways| Kartikey Hariyani | Chargezone",
    href: "/ep-20-electrifying-indian-highways-kartiey-hariyani-chargezone/",
  },
  {
    img: Ep19Img,
    alt: "EP 19 Cyrus Dhabar",
    title: "EP 19 | What are EV Manufacturers doing wrong? | Cyrus Dhabar | Powerdrift",
    href: "/ep-19-what-are-the-ev-manufacturers-doing-wrong-cyrus-dhabar-powerdrift/",
  },
  {
    img: Ep18Img,
    alt: "E18 Rajeev Chaba",
    title: "E18 | Is this the right time to move from ICE vehicles to EVs? | Rajeev CHABA | MG Motor India",
    href: "/e18-are-evs-truly-100-clean-mobility-rajeev-chaba-mg-motor-india/",
  },
  {
    img: Ep17Img,
    alt: "E17 K.R. Jyothilal",
    title: "E17 | What does it take to build India's most electrified state for zero-emission mobility | K.R. JYOTHILAL IAS",
    href: "/e17-what-does-it-take-to-build-indias-most-electrified-state-k-r-jyothilal-ias/",
  },
  {
    img: Ep16Img,
    alt: "EP 16 Alisha Sachdev",
    title: "EP 16 | Does China control the Indian E Mobility Sector? | Alisha Sachdev | CNBC TV 18",
    href: "/ep-16-does-china-control-the-indian-e-mobility-sector-alisha-sachdev-cnbc-tv-18/",
  },
  {
    img: Ep15Img,
    alt: "EP 15 Sajid Mubashir",
    title: "EP15 | Exploring the R&D roadmap of EVs in India | Sajid MUBASHIR | Ministry of Science & Technology",
    href: "/ep15-exploring-the-rd-roadmap-of-evs-in-india-sajid-mubasir-ministry-of-science-technology/",
  },
  {
    img: Ep14Img,
    alt: "E14 JBM",
    title: "E14 | Buses of the future – changing how India gets to work | JBM",
    href: "/e-14-buses-of-the-future-changing-how-india-gets-to-work-jbm/",
  },
  {
    img: Ep12Img,
    alt: "E12 Chargezone",
    title: "E12 | Which comes first… the infrastructure or the EVs | Chargezone",
    href: "/e12-which-comes-first-the-infrastructure-or-the-evs-chargezone/",
  },
  {
    img: Ep11Img,
    alt: "E11 MG Motors India",
    title: "E11 | Electrifying an automotive icon | MG Motors India",
    href: "/e10-electrifying-an-automotive-icon/",
  },
  {
    img: Ep10Img,
    alt: "E10 Hero Electric",
    title: "E10 | The \"HERO\" Of EVs | Hero Electric Pvt Ltd",
    href: "/e10-the-hero-of-evs-hero-electric-pvt-ltd/",
  },
  {
    img: Ep09Img,
    alt: "E09 Nexus Power",
    title: "E09 | Electric Vehicles Powered By Farm Waste | Nexus Power",
    href: "/e09-electric-vehicles-powered-by-farm-waste-nexus-power/",
  },
  {
    img: null,
    alt: "E08 EV Consumer",
    title: "E08 | Candid conversation with a \"Significant\" EV Consumer on his 1500km adventure",
    href: "/e08-candid-conversation-with-a-significant-ev-consumer-on-his-1500km-adventure/",
  },
  {
    img: Ep07Img,
    alt: "E07 Reji Kumar Pillai",
    title: "E07 | Candid Conversation with Reji Kumar PILLAI, President of India Smart Grid Forum on charging standards in India, & the power grid's ability to accommodate a massive move to E-Mobility",
    href: "/e07-candid-conversation-with-reji-kumar-pillai-president-of-india-smart-grid-forum-on-charging-standards-in-india-the-power-grids-ability-to-accommodate-a-massive-move-to-e-mobility/",
  },
  {
    img: Ep06Img,
    alt: "E06 Mahesh Babu",
    title: "E06 | Candid conversation with Mahesh BABU, MD & CEO at Mahindra Electric Mobility Ltd on their plans to sell 500,000 EVs in India",
    href: "/e06-candid-conversation-with-mahesh-babu-md-ceo-at-mahindra-electric-mobility-ltd-on-their-plans-to-sell-500000-evs-in-india/",
  },
  {
    img: null,
    alt: "E05 Gigafactories",
    title: "E05 | Fireside Chat With Industry Leaders On What Will Happen When The Gigafactories Arrive In India",
    href: "/e05-fireside-chat-with-industry-leaders-on-what-will-happen-when-the-gigafactories-arrive-in-india/",
  },
  {
    img: Ep04Img,
    alt: "E04 Sulajja Firodia Motwani",
    title: "E04 | Candid conversation with Sulajja FIRODIA MOTWANI, Founder & CEO at Kinetic Green Energy on achieving the electric dream in India",
    href: "/e04-candid-conversation-with-sulajja-firodia-motwani-founder-ceo-at-kinetic-green-energy-on-achieving-the-electric-dream-in-india/",
  },
  {
    img: Ep03Img,
    alt: "E03 Tarun Mehta",
    title: "E03 | Candid conversation with Tarun MEHTA, Co-founder & CEO at Ather Energy on his journey to launch a game changing Electric Scooter whilst raising $135M along the way",
    href: "/e03-candid-conversation-with-tarun-mehta-co-founder-ceo-at-ather-energy-on-his-journey-to-launch-a-game-changing-electric-scooter-whilst-raising-135m-along-the-way/",
  },
  {
    img: Ep02Img,
    alt: "E02 Stefan Louis",
    title: "E02 | Candid conversation with Stefan LOUIS, CEO of Nexcharge on the evolution of lithium industry in India",
    href: "/e02-candid-conversation-with-stefan-louis-ceo-of-nexcharge-on-the-evolution-of-lithium-industry-in-india/",
  },
  {
    img: Ep01Img,
    alt: "E01 Maxon Lewis",
    title: "E01 | Candid conversation with Maxon LEWIS, MD of Magenta Power on the road map to 100% E-Mobility in India",
    href: "/candid-conversation-with-maxon-lewis/",
  },
];

/* ─────────────────────────────────────────────
   CARD
───────────────────────────────────────────── */
function EpisodeCard({ img, alt, title, href }) {
  return (
    <div className="ev-card-wrap">
      <a href={href} className="ev-card" rel="noreferrer">
        {img && <img src={img} alt={alt} />}
      </a>
      <p className="ev-card__title">{title}</p>
      <a href={href} className="ev-card__read-more" rel="noreferrer">
        Read More <ArrowIcon />
      </a>
    </div>
  );
}

/* ─────────────────────────────────────────────
   ROOT
───────────────────────────────────────────── */
export default function EVEpisodes() {
  const gridRef = useRef(null);

  useEffect(() => {
    const cards = gridRef.current?.querySelectorAll(".ev-card-wrap") || [];
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("ev-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    cards.forEach((card) => observer.observe(card));
    return () => observer.disconnect();
  }, []);

  return (
    <>
      <style>{CSS}</style>
      <div className="ev-page">
        <div className="ev-inner">
          <h1 className="ev-page-title">EV Episodes</h1>
          <div className="ev-grid" ref={gridRef}>
            {EPISODES.map((ep, i) => (
              <EpisodeCard key={i} {...ep} />
            ))}
          </div>
        </div>
      </div>
    </>
  );
}